module.exports = __webpack_public_path__ + "static/media/renewal.3cbd005b.svg";